module.exports = __webpack_public_path__ + "media/img/naked-logo-fedf0a522b85166d2f30e5bac8f46bb1.png";